
import React from "react";
import { Row, Col } from "react-bootstrap";
import rocketIcon from "../../assets/Group 13.png";
import workflowIcon from "../../assets/Group 3.png";
import assistIcon from "../../assets/Group 6.png";
import plusIcon from "../../assets/Group 17.png";
import "./HomeNotification.css";

const moduleIcons = {
  "Code Enhance": plusIcon,
  "Code Accelerate": rocketIcon,
  "Code Workflow": workflowIcon,
  "Code Assist": assistIcon,
};

const HomeNotification = ({ tasks, accessibleModules = [], onTaskClick }) => {
  // Filter tasks based on accessible modules
  const filteredTasks = tasks.filter((task) =>
    accessibleModules.includes(task.module)
  );

  return (
    <div className="home-notification-container">
      <div className="separator-line"></div>
      <h5 className="notification-title">Pick up where you left off</h5>

      {filteredTasks.map((task, index) => (
        <Row
          key={index}
          className={`notification-item ${index % 2 === 0 ? "even-row" : "odd-row"} ${
            index === filteredTasks.length - 1 ? "last-item" : ""
          }`}
          onClick={() => onTaskClick && onTaskClick(task)}
          style={{ cursor: onTaskClick ? "pointer" : "default", alignItems: "center" }}
        >
          <Col xs={1} className="notification-icon">
            <div className="icon-wrapper">
              <img
                src={moduleIcons[task.module] || plusIcon}
                alt="icon"
                className="icon-notification"
              />
            </div>
          </Col>
          <Col xs={11} className="notification-details">
            <div className="detail-wrapper">
              {task.id && <>ID: <strong className="value-text">{task.id}</strong></>}
              {task.specialty && <> Specialty: <strong className="value-text">{task.specialty}</strong></>}
              {task.dischargeDate && <> Discharge Date: <strong className="value-text">{task.dischargeDate}</strong></>}
              {task.status && <> Status: <strong className="value-text">{task.status}</strong></>}
            </div>
          </Col>
        </Row>
      ))}

      {filteredTasks.length === 0 && (
        <div className="no-notifications">No tasks available</div>
      )}
    </div>
  );
};

export default HomeNotification;

